<template>
    <div class="slideshow">

        <div>
            <!--<div>-->
                <!--<div v-for="src in list" :key="src.name">-->
                    <jumbo-image v-for="src in list" :key="src.name" :src="src" :index="index" ref="slide" class="slide" @next="next()" @progress="progress"/>
                <!--<div v-for="src in list" :key="src.name" ref="slide" xclass="slide">bbb</div>-->
                <!--</div>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import JumboImage from "./JumboImage";

    const listDesktop = [

        [
            {type: 'image', name: 'maximalaufgeladen01.jpg', label: 'smart electric challenge'},
            {type: 'video', name: 'maximalaufgeladen.mp4', label: 'smart electric challenge'},
            {type: 'image', name: 'maximalaufgeladen03.jpg', label: 'smart electric challenge'}

        ],
        [
            {type: 'image', name: 'cheops01.jpg', label: 'cheops adventure'},
            {type: 'video', name: 'cheops.mp4', label: 'cheops adventure'},
            {type: 'image', name: 'cheops02.jpg', label: 'cheops adventure'}

        ],
        [
            {type: 'image', name: 'sunbath01.jpg', label: 'sunbath weather app'},
            {type: 'video', name: 'sunbath.mp4', label: 'sunbath weather app'},
            {type: 'image', name: 'sunbath02.jpg', label: 'sunbath weather app'}

        ],
        [
            {type: 'image', name: 'battleboats01.jpg', label: 'battleboats.io'},
            {type: 'image', name: 'battleboats02.jpg', label: 'battleboats.io'},
            {type: 'video', name: 'battleboats.mp4', label: 'battleboats.io'},
            {type: 'image', name: 'battleboats03.jpg', label: 'battleboats.io'}

        ],

        [
            {type: 'image', name: 'jumbled01.jpg', label: 'jumbled.io'},
            {type: 'video', name: 'jumbled.mp4', label: 'jumbled.io'},
            {type: 'image', name: 'jumbled02.jpg', label: 'jumbled.io'}

        ],

        [
            {type: 'image', name: 'supersnake01.jpg', label: 'supersnake.io'},
            {type: 'video', name: 'supersnake.mp4', label: 'supersnake.io'},
            {type: 'image', name: 'supersnake02.jpg', label: 'supersnake.io'}

        ]
    ];

    /*const listMobile = [
        [
            {type: 'image', name: 'maximalaufgeladen01.jpg'},
            {type: 'image', name: 'maximalaufgeladen03.jpg'}

        ],

        [
            {type: 'image', name: 'cheops01.jpg'},
            {type: 'image', name: 'cheops02.jpg'}

        ],
        [
            {type: 'image', name: 'sunbath01.jpg'},
            {type: 'image', name: 'sunbath02.jpg'}

        ],
        [
            {type: 'image', name: 'battleboats01.jpg'},
            {type: 'image', name: 'battleboats02.jpg'},
            {type: 'image', name: 'battleboats03.jpg'}

        ],
        [
            {type: 'image', name: 'jumbled01.jpg'},
            {type: 'image', name: 'jumbled02.jpg'}

        ],
        [
            {type: 'image', name: 'supersnake01.jpg'},
            {type: 'image', name: 'supersnake02.jpg'}

        ]
    ];*/

    export default {
        name: "Slideshow",
        components: {JumboImage},
        data() {
            return {
                index: 0,
                slides: null,
                currentSlide: null,
                list: null
            }
        },
        methods: {
            progress(p) {
                this.$emit('progress', p);
            },
            next() {
                const oldSlide = this.currentSlide;
                this.index++;
                if (this.index == this.slides.length) {
                    this.index = 0;
                }
                this.currentSlide = this.slides[this.index];
                this.currentSlide.show(oldSlide);
                this.$emit('nextslide', this.currentSlide.src);
            }
        },
        created() {
            /* const shuffle = (array) => {
                 for (let i = array.length - 1; i > 0; i--) {
                     const j = Math.floor(Math.random() * (i + 1));
                     const temp = array[i];
                     array[i] = array[j];
                     array[j] = temp;
                 }
             };*/


            // const l0 = isMobile.any ? listMobile : listDesktop;
            // const first = l0.shift();


            // shuffle(l0);
            // shuffle(l0);

            // l0.unshift(first);

            const l0 = listDesktop;

            let list = [];

            for (let i = 0; i < l0.length; i++) {
                list = list.concat(l0[i]);
            }

            this.list = list;


        },
        mounted() {

            this.slides = this.$refs.slide.slice();
            this.currentSlide = this.slides[0];
            this.currentSlide.show();
            this.$emit('nextslide', this.currentSlide.src);
        }
    }
</script>

<style lang="scss" scoped>
    .slideshow {
        position: absolute;
        width: 100vw;
        height: 100vh;
        z-index: -1;
        top: 0;
        left: 0;
    }

    .slide {
        position: absolute;
        width: 100vw;
        height: 100vh;
        z-index: 5;
    }


</style>